import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CollapsibleSection, TableInputConfig } from '@app/shared/table/table.component';
import { BenutzerStatus } from '@pezi/entities';
import { NgClass, NgIf, NgFor, NgStyle } from '@angular/common';
import { TextSmallDirective } from '../../core/directive/text-small.directive';
import { MatDivider } from '@angular/material/divider';
import { MatSelectionList, MatListOption, MatListItemIcon } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector:        'app-list',
  templateUrl:     './list.component.html',
  styleUrls:       ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true,
  imports:         [
    NgClass,
    NgIf,
    TextSmallDirective,
    MatDivider,
    MatSelectionList,
    NgFor,
    MatListOption,
    MatIcon,
    MatListItemIcon,
    NgStyle,
    MatTooltip
  ]
})
export class ListComponent {

  @Input()
  header: string;

  @Input()
  subHeader: string;

  @Input()
  entries: ListEntry[];

  @Input()
  isSingleLineList = false;

  @Input()
  withShadow = true;

  @Input()
  nodataText = 'Keine Daten vorhanden';

  @Input()
  nodataIcon = 'cloud_off';

  @Input()
  globalDisabled = false;

  @Output()
  public customButtonClick = new EventEmitter();

  @Output()
  public listEntryClick = new EventEmitter();

  constructor(private snackBar: MatSnackBar, private cd: ChangeDetectorRef) { }

  public updateListInView(): void {
    this.cd.markForCheck();
  }

  public emitClick(item: ListEntry): void {
    if (!item.disabled && !this.globalDisabled) {
      this.listEntryClick.emit(item);
    }
  }

  public showInfoText(text: string): void {
    this.snackBar.open(text);
  }
}

export interface ListEntry<T = unknown> {
  text?: string;
  subtext?: string;
  additionalText?: string;
  imageURL?: string;
  imageIcon?: string,
  imageIconColor?: ImageIconColor;
  imageIconTooltip?: string;
  fallbackURL?: string;
  id?: string;
  checked?: boolean;
  routerLink?: string;
  data?: T;
  disabled?: boolean;
  infoText?: string;
  onlineStatus?: BenutzerStatus;
  collapsableSectionData?: CollapsibleSection[] | (() => Promise<CollapsibleSection[]>);
  highlighted?: boolean;
  highlightedSecondary?: boolean;
  formGroup?: FormGroup;
}

export interface ListEntryWithID<T = unknown> extends ListEntry<T> {
  id: string;
}

export enum ImageIconColor {
  SUCCESS = 'success',
  ERROR = 'error'
}
